import { createContext } from "react";

export const StaffContext = createContext({});